import styled from 'styled-components';
import { grey25, grey50, navy, white } from '@zocdoc/branding/colors';

// TODO: Go back to index import when we are on webpack 4
import { PaddedContainer } from '../../Layout/PaddedContainer';
import { NumColumns } from '../../grid';
import { Arrow } from '../../icons';
import { FontFamily } from '../../typography';

import { DESKTOP_DAY_COLUMN_SIZE } from '../constants/ViewConstants';

export const DesktopWrapper = styled.div`
    align-items: center;
    display: flex;
    position: relative;
    user-select: none;
    width: 100%;
`;

export const DesktopDayColumn = styled.div`
    color: ${navy};
    font: 15px/20px ${FontFamily.SharpSansSemibold};
    padding: 2px 0;
    text-align: center;
    width: ${p => (DESKTOP_DAY_COLUMN_SIZE[p.sizeId] / NumColumns) * 100}%;
`;

const CIRCLE_SIZE = 36;

/**
 * using role="button" instead of an actual button element because
 * several browsers do not allow <button> elements to be display: flex
 * more info: https://github.com/philipwalton/flexbugs#9-some-html-elements-cant-be-flex-containers
 */
export const DesktopNavigationToggle = styled.div.attrs({ role: 'button' })`
    align-items: center;
    align-self: stretch;
    background-color: transparent;
    border: 0;
    display: flex;
    justify-content: center;
    line-height: 0;
    position: relative;
    width: ${(2 / NumColumns) * 100}%;
    z-index: 1;

    &:not([disabled]) {
        color: ${navy};
        cursor: pointer;

        &:hover,
        &:active {
            &:before {
                border-radius: 100%;
                content: '';
                position: absolute;
                top: 50%;
                left: 50%;
                margin-top: -${CIRCLE_SIZE / 2}px;
                margin-left: -${CIRCLE_SIZE / 2}px;
                height: ${CIRCLE_SIZE}px;
                width: ${CIRCLE_SIZE}px;
                z-index: -1;
            }
        }

        &:hover {
            &:before {
                background: ${grey25};
            }
        }

        &:active {
            color: white;

            &:before {
                background: ${navy};
            }
        }
    }

    &[disabled] {
        color: ${grey50};
        cursor: not-allowed;
        pointer-events: none;
    }
`;

export const DesktopStyledDate = styled.div`
    font-family: ${FontFamily.SharpSansBold};
`;

export const MobileWrapper = styled(PaddedContainer)`
    align-items: center;
    background-color: ${white};
    color: ${navy};
    display: flex;
    font-family: ${FontFamily.SharpSansBold};
    height: 48px;
    justify-content: space-between;
    position: relative;
    text-align: center;
    user-select: none;
    width: 100%;
`;

export const MobileRail = styled.div`
    white-space: nowrap;
`;

/**
 * using role="button" instead of an actual button element because
 * several browsers do not allow <button> elements to be display: flex
 * more info: https://github.com/philipwalton/flexbugs#9-some-html-elements-cant-be-flex-containers
 */
export const MobileNavigationToggle = styled.div.attrs({ role: 'button' })`
    align-items: center;
    align-self: stretch;
    background-color: transparent;
    border: 0;
    color: currentcolor;
    cursor: pointer;
    display: flex;
    font: 13px/1 ${FontFamily.SharpSansSemibold};
    white-space: nowrap;

    &[disabled] {
        color: ${grey50};
        pointer-events: none;
    }
`;

const ARROW_HEIGHT = 16;

export const MobileLeftArrow = styled(Arrow).attrs({
    color: 'currentcolor',
    direction: 'left',
    height: ARROW_HEIGHT,
})`
    margin-right: 12px;
`;

export const MobileRightArrow = styled(Arrow).attrs({
    color: 'currentcolor',
    direction: 'right',
    height: ARROW_HEIGHT,
})`
    margin-left: 12px;
`;
